import React from 'react'

export default function Footer() {
  return (
    <footer style={{ backgroundColor: 'black', color: 'white' }}><br />
      <h1 style={{ textAlign: 'center' }}>Web Blog</h1><br />
      <div className="main4">
        <h3>Place to gain knowledge about web development</h3>
        <div className="input">
          <h2>Let's Connect</h2>
          <div className="input_area">
            <input type="text" placeholder='email' style={{ borderRadius: '10px', textAlign: 'center' }} />
            <button className='btn btn-danger'>Submit</button>
          </div>
        </div>
      </div>
    </footer>
  )
}
